import { createContext, Dispatch } from 'react';
import { getInitialSearchMockState } from './store/store.action';
import { InitialSearchResult } from './store/store.reducer';
import { UpdateSearchStateActionType, SearchStateStoreDataType, SearchResultDataType } from './store/store.type';
import { SearchResultAlertType } from './index.types';
import { hardCodedAllLocale } from './index.constant';

interface SearchFilterContextType {
  searchQueryState: SearchStateStoreDataType;
  setSearchQuery: Dispatch<UpdateSearchStateActionType>;
}

interface SearchResultContextType {
  searchResult: SearchResultDataType;
  setSearchResult: Dispatch<UpdateSearchStateActionType>;
}

export const SearchFilterContext = createContext<SearchFilterContextType>({
  searchQueryState: getInitialSearchMockState({}, false, hardCodedAllLocale.en, '', false, '', false),
  setSearchQuery: () => {
    //TODO : empty function
  },
});

export const SearchResultContext = createContext<SearchResultContextType>({
  searchResult: InitialSearchResult,
  setSearchResult: () => {
    //TODO : empty function
  },
});

interface SearchResultAlertContextType {
  searchResultAlerts: SearchResultAlertType;
  setSearchResultAlerts: Dispatch<SearchResultAlertType>;
}
export const SearchResultAlertContext = createContext<SearchResultAlertContextType>({
  searchResultAlerts: {},
  setSearchResultAlerts: () => {
    //TODO : empty function
  },
});

interface MapViewContextType {
  selectedHotel: unknown[];
  setSelectedHotel: (hotel: unknown) => void;
  open: boolean;
  setOpen: (open: boolean) => void;
  /** True when response contains a single property (e.g., availability_calendar_search) */
  isSinglePropertyResponse?: boolean;
}

export const MapViewContext = createContext<MapViewContextType>({
  selectedHotel: [],
  setSelectedHotel: () => {
    //TODO : empty function
  },
  open: false,
  setOpen: () => {
    //TODO : empty function
  },
  isSinglePropertyResponse: false,
});
